export default "__VITE_ASSET__BWz_fU$l__"